import { useState, useEffect } from 'react';
import { IAppContext as CareerPageSettings, getCareerPageSettings } from 'wisestep-api';

import { defaultSettings } from '../../src/features/careerPageSettings/util';
import { careerPageSettingStore } from '../utils/careerPageSettingsStore';

const useCareerPageSettings = () => {
  const [careerPageSetting, setCareerPageSetting] = useState<CareerPageSettings>(defaultSettings());
  const careerPageSettings = careerPageSettingStore((state) => state.careerPageSettings);
  const setCareerPageSettings = careerPageSettingStore((state) => state.setCareerPageSettings);

  useEffect(() => {
    const jobDetails = async () => {
      if (!careerPageSettings) {
        const careerPageSettingsDetails = await getCareerPageSettings();
        setCareerPageSetting(careerPageSettingsDetails.data);
        setCareerPageSettings(careerPageSettingsDetails.data);
      } else {
        setCareerPageSetting(careerPageSettings);
      }
    };
    jobDetails();
  }, [careerPageSettings, setCareerPageSettings]);
  return careerPageSetting;
};
export default useCareerPageSettings;
